import React, {useState, useEffect, useContext, useMemo, useRef} from 'react'
import { useTranslation } from "react-i18next";
import {GetAlertsComponent,setObjectByPath,translateType, handleTranslation, handleAlphabeticallySort} from "./utils"
import TextField from "@material-ui/core/TextField";
import _ from "lodash"
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import RulesContext from "../../../../context/rules-context"
import { Autocomplete } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';

const AnimatedPopper = function(props) {
    const { open, children, ...other } = props;

    const lastValidChildren = useRef(children);
    useEffect(() => {
        if (open) {
            lastValidChildren.current = children;
        }
    }, [open, children]);

    return (
        <Popper
            open={open}
            {...other}
            transition
            placement='top'
            style={{ width: 'fit-content', minWidth: '220px' }}
        >
            {({ TransitionProps }) => (
                <Grow
                    {...TransitionProps}
                    style={{ transformOrigin: 'bottom' }}
                >
                    <div>
                        {open ? children : (lastValidChildren.current || children)}
                    </div>
                </Grow>
            )}
        </Popper>
    );
};

export function ProcessorsVariablesBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    let processorsVariables = useContext(RulesContext).processors_variables
    let variable = processorsVariables.filter(variable => variable.path === node.node.properties.path)[0]

    const handleMaskBoxLabelTranslation = (variable) => {
        if((variable).path?.includes('enricher_employer_data')){
            let path = (variable).path.split('.')
            let employerDataPrefix = path[0]
            let variableDescriptionSuffix = path.slice(1).join('').replace('_', '');

            let translation = t(employerDataPrefix) + t(variableDescriptionSuffix);
            return translation;
        } else {
            return t((variable).path?.split('.').join(''))
        }
    }

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {
                            variable ? handleMaskBoxLabelTranslation(variable) : ''
                        }
                        {(node.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null}
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {
                            variable ? handleMaskBoxLabelTranslation(variable) : ''
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export function ProcessorsVariablesConfiguration(props) {
    const { t, i18n } = useTranslation()
    let { node } = props
    let { read_only } = props
    let { handleNodeChange } = props
    let { handleConfigurationClose } = props

    const rawProcessorsVariables = useContext(RulesContext).processors_variables

    const [processorsVariables, setProcessorsVariables] = useState(() => {
        let processed = handleTranslation(rawProcessorsVariables)
        return handleAlphabeticallySort(processed, 'description')
    })

    useEffect(() => {
        let processed = handleTranslation(rawProcessorsVariables)
        setProcessorsVariables(handleAlphabeticallySort(processed, 'description'))
    }, [rawProcessorsVariables, i18n.resolvedLanguage])

    const variableGroups = useMemo(() => {
        const groups = processorsVariables
            .map(v => v.variables_group)
            .filter((val, id, array) => val && array.indexOf(val) === id)
        return groups.sort()
    }, [processorsVariables])

    const variableTypes = useMemo(() => {
        const types = processorsVariables
            .map(v => v.type)
            .filter((val, id, array) => val && array.indexOf(val) === id)
        return types.sort()
    }, [processorsVariables])

    const [nodeState, setNodeState] = useState(node)
    const [selectedGroup, setSelectedGroup] = useState("Todas")
    const [selectedType, setSelectedType] = useState("Todos");

    useEffect(() => {
        if (nodeState.node.properties.path && processorsVariables.length > 0) {
            const currentVar = processorsVariables.find(v => v.path === nodeState.node.properties.path)
            if (currentVar){
                if(currentVar.variables_group) setSelectedGroup(currentVar.variables_group)
                if(currentVar.type) setSelectedType(currentVar.type)
            }
        }
    }, [nodeState, processorsVariables])

    const handleGroupChange = (e) => {
        setSelectedGroup(e.target.value)
        handleEventChange({ target: { value: "" } })
    }

    const handleTypeChange = (e) => {
        setSelectedType(e.target.value)
        handleEventChange({ target: { value: "" } })
    }

    const handleEventChange = (e) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node, "properties.path", e.target.value)
        setNodeState(new_node)
    }

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(nodeState)
    }

    const validateAllValues = () => {
        return (nodeState.node.properties.path && nodeState.node.properties.path.length > 0)
    }

    const filteredVariables = useMemo(() => {
        return processorsVariables.filter(v => {
            const matchesGroup = selectedGroup === "Todas" || v.variables_group === selectedGroup;
            const matchesType = selectedType === "Todos" || v.type === selectedType;
            return matchesGroup && matchesType;
        });
    }, [selectedGroup, selectedType, processorsVariables]);

    const categoryOptions = ['Todas', ...variableGroups]
    const variableTypeOptions = ['Todos', ...variableTypes]

return (
        <div style={{height: 'fit-content'}}>
            <div style={{ display: "flex", padding: "16px 20px 12px 20px" }}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help, index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{ fontSize: "14px", display: "flex", margin: "auto 5px" }} />
                </Tooltip>
            </div>
            <div style={{
                height: 'fit-content',
                flexGrow: "1",
                padding: "0 10px 20px 10px",
                marginTop: "0px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                <div className="internalCardContainer"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: '90%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '0',
                        gap: '12px',
                        flexGrow: 1
                }}>
                    <div style={{ display: 'flex', width: '100%', gap: '15px' }}>
                        <Tooltip title={t(selectedGroup)} placement="left" arrow>
                            <Autocomplete
                                options={categoryOptions}
                                getOptionLabel={(option)=> t(option)}
                                value={selectedGroup}
                                onChange={(event, newValue) => {
                                    if (newValue) handleGroupChange({ target: { value: newValue } })
                                }}
                                readOnly={read_only}
                                fullWidth
                                disableClearable
                                PopperComponent={AnimatedPopper}
                                componentsProps={{paper: { elevation: 8, sx: { borderRadius: '4px' }}}}
                                ListboxProps={{style: { maxHeight: '80vh' }}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t("Categoria")}
                                        size="small"
                                        className="filterTextbox"
                                        style={{ width: "100%"}}
                                        sx={{
                                            '& .MuiInputBase-root': { cursor: 'pointer' },
                                            '& .MuiInputBase-input': { cursor: 'pointer' }
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: true
                                        }}
                                    />
                                )}
                            />
                        </Tooltip>
                        <Tooltip title={t(selectedType)} placement="right" arrow>
                            <Autocomplete
                                options={variableTypeOptions}
                                getOptionLabel={(option)=> t(option)}
                                value={selectedType}
                                onChange={(event, newValue) => {
                                    if (newValue) handleTypeChange({ target: { value: newValue } })
                                }}
                                readOnly={read_only}
                                fullWidth
                                PopperComponent={AnimatedPopper}
                                disableClearable
                                componentsProps={{paper: { elevation: 8, sx: { borderRadius: '4px' }}}}
                                ListboxProps={{style: { maxHeight: '80vh' }}}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={t("Tipo")}
                                        size="small"
                                        className="filterTextbox"
                                        style={{ width: "100%"}}
                                        sx={{
                                            '& .MuiInputBase-root': { cursor: 'pointer' },
                                            '& .MuiInputBase-input': { cursor: 'pointer' }
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            readOnly: true
                                        }}
                                    />
                                )}
                            />
                        </Tooltip>
                    </div>
                    <Autocomplete
                        options={filteredVariables}
                        getOptionLabel={(option) => `${t(option.description)} (${t(translateType(option.type))})`}
                        value={processorsVariables.find(v => v.path === nodeState.node.properties.path) || null}
                        onChange={(event, newValue) => {
                            handleEventChange({ target: { value: newValue ? newValue.path : "" } });
                        }}
                        fullWidth
                        readOnly={read_only}
                        disableClearable
                        PopperComponent={AnimatedPopper}
                        componentsProps={{paper: { elevation: 8, sx: { borderRadius: '4px' }}}}
                        ListboxProps={{style: { maxHeight: '80vh' }}}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("Campo")}
                                size="small"
                                className="filterTextbox"
                                style={{ textAlign: "center", width: "100%"}}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-root': { justifyContent: 'center' }
                                }}
                            />
                        )}
                    />
                </div>
                <div style={{ display: "flex", margin: "auto auto 5px auto" }}>
                    <div
                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                        style={{ width: "120px" }}
                        onClick={handleConfigurationClose}
                    >
                        {read_only ? "X" : t("discard")}
                    </div>
                    {!read_only &&
                        <div
                            className={
                                validateAllValues()
                                    ? ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                    : ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                            style={{ width: "120px" }}
                            onClick={validateAllValues() ? handleSave : null}
                        >
                            {t("save")}
                        </div>}
                </div>
            </div>
        </div>
    )
}

export class ProcessorsVariablesBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        let put_error = false
        let alerts = []

        let processorsVariables = this.rulesContext.processors_variables

        let paths_list = processorsVariables.reduce((acc, option) => {
            acc.push(option.path)
            return acc
        },[])

        if((node.node.children || []).length !== 0){
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }
        if (!paths_list.includes(node.node.properties.path)){
            put_error = true
            alerts.push("Clique no nó deste Variáveis do Processador, abra a configuração e escolha uma opção válida")
        }
        //Validate if parent is valid
        if (node.parentNode != null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválida")
            }
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        let processorsVariables = this.rulesContext.processors_variables
        let variable = processorsVariables.filter(variable => variable.path === node.properties.path)[0]
        return (variable || {type:""}).type
    }
}
